import React from "react";

/** PageHeader — title with kebab-case data-testid for routes. */
const PageHeader = ({ tag, title, subtitle, accent = "cyan", actions }) => {
  const accentClass = accent === "pink" ? "text-fuchsia-400 text-glow-pink" : "text-cyan-400 text-glow-cyan";
  return (
    <div className="flex items-end justify-between border-b border-slate-800 pb-5 mb-6">
      <div>
        <div className={`text-[10px] uppercase tracking-[0.3em] ${accentClass}`}>{tag}</div>
        <h1 data-testid="page-title" className="font-display text-2xl md:text-3xl font-bold mt-1.5 tracking-wide">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-400 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};

export default PageHeader;
